export const technos = {
    RPA: 'rpa',
    BI: 'bi',
    IA: 'ia',
    DEVOPS: 'devops',
    BPM: 'bpm',
}